import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v } from '@dojo/framework/core/vdom';
import { beforeProperties } from '@dojo/framework/core/decorators/beforeProperties';
import { DNode, WidgetProperties } from '@dojo/framework/core/interfaces';
import { Store } from '@dojo/framework/stores/Store';

import { QuizMeta } from '../interfaces';

import css from '../css/prometric.m.css';

export interface CountdownTimerProperties {
	quizstore: Store<QuizMeta>;
	countdown: string;
}

@theme(css)
export class CountdownTimer extends I18nThemed<CountdownTimerProperties> {
	private _propsInited: boolean = false;

	protected render(): DNode {
		const { countdown } = this.properties;
		const isNeg = countdown && countdown.startsWith('-');
		const classes = isNeg ? [this.theme(css.timerNegative)] : [];
		return v('span', { classes }, [v('i', { classes: ['far', 'fa-clock', css.actionIcon] }), countdown]);
	}

	@beforeProperties()
	protected stateProperties(
		properties: CountdownTimerProperties & WidgetProperties
	): CountdownTimerProperties & WidgetProperties {
		const { quizstore } = properties;
		const { get, path } = quizstore;

		if (!this._propsInited) {
			const paths = [['countdown']];
			const invalidatePaths = paths.map((path: any) => quizstore.path(path.join('/')));
			const handle = quizstore.onChange(invalidatePaths, () => this.invalidate());
			this.own({
				destroy: () => {
					handle.remove();
				}
			});
			this._propsInited = true;
		}

		properties.countdown = get(path('countdown'));
		return properties;
	}
}
